import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import {
  config,
  getCompleteDomain,
  getServerEnvironment,
} from "../utils/helper";
import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
import swal from "sweetalert";
import { useDispatch, useSelector } from "react-redux";
import DisplaySettingsIcon from "@mui/icons-material/DisplaySettings";
import SettingsIcon from "@mui/icons-material/Settings";
import PersonIcon from "@mui/icons-material/Person";
import HandymanIcon from "@mui/icons-material/Handyman";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import ContactEmergencyIcon from "@mui/icons-material/ContactEmergency";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { resetUserPrivileges } from "../store/slices/userPrivilegesSlice";
import Cookies from "js-cookie";
import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";

export default function SideBar() {
  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState(false);
  const [expandedmasterMerchant, setExpandedMasterMerchant] = useState(false);
  const [expandedExternal, setExpandedExternal] = useState(false);
  const [expandedmaster, setexpandedmaster] = useState(false);
  const [expandedCustomer, setexpandedCustomer] = useState(false);
  const [expandedonBoarding, setexpandedonBoarding] = useState(false);
  const [expandedTools, setExpandedTools] = useState(false);
  const [expandedSettings, setExpandedSettings] = useState(false);
  const [toggle, setToggle] = useState(true);
  const { logoPath, Name } = config(getServerEnvironment(getCompleteDomain()));
  const navigate = useNavigate();

  const { userCatalog } =
    useSelector((state) => state.userPrivileges);

  const handleClearLocalStorage = (event) => {
    event?.preventDefault?.();

    const storedToken = localStorage?.getItem?.("token") || null;

    swal({
      title: "Alert",
      text: "Are You Sure You Want To Logout?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willLogout) => {
        if (willLogout === true) {
          try {
            localStorage?.removeItem?.("token");
          } catch {
          }

          try {
            Cookies?.remove?.("access_token");
          } catch { }

          try {
            document.cookie =
              "access_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          } catch { }

          try {
            dispatch?.(resetUserPrivileges?.());
          } catch { }

          swal("Logged Out Successfully", { icon: "success" })
            .then(() => {
              navigate?.("/");
            })
            .catch(() => {
              navigate?.("/");
            });
        } else {
          if (storedToken && typeof storedToken === "string") {
            try {
              localStorage?.setItem?.("token", storedToken);
            } catch { }
          }
        }
      })
      .catch(() => {
        // ✅ If swal itself fails → safe exit
        if (storedToken && typeof storedToken === "string") {
          localStorage?.setItem?.("token", storedToken);
        }
      });
  };

  const handleToggle = (toggleState, setToggleState) => {
    setToggleState(!toggleState);
  };

  const handleHumbergur = () => {
    setToggle(!toggle);
    if (toggle) {
      document.getElementById("main-wrapper").classList.remove("menu-toggle");
      document.getElementById("hamburger").classList.remove("is-active");
    } else {
      document.getElementById("hamburger").classList.add("is-active");
      document.getElementById("main-wrapper").classList.add("menu-toggle");
    }
  };

  useEffect(() => {
    if (window.innerWidth < 768) {
      handleHumbergur();
    }
  }, []);

  const isModuleVisible = (module) => {
    return !!userCatalog[module];
  };

  const toolPrefix = "Tools";

  const hasAnyTools = Object.keys(userCatalog).some((key) =>
    key.startsWith(toolPrefix)
  );

  return (
    <>
      <div class="nav-header">
        <a class="brand-logo">
          <img src={logoPath} width="53" height="53px" />
          <h1 width="124px" height="33px" class="brand-title">
            {Name}
          </h1>
        </a>
        <div class="nav-control" onClick={handleHumbergur}>
          <div id="hamburger" class="hamburger">
            <span class="line"></span>
            <span class="line"></span>
            <span class="line"></span>
          </div>
        </div>
      </div>
      <div className="dlabnav " style={{ overflowY: "scroll" }}>
        <div className="dlabnav-scroll">
          <ul className="metismenu" id="menu">
            <li className="dropdown header-profile">
              <a
                className="nav-link"
                href="javascript:void(0);"
                role="button"
                Name
                data-bs-toggle="dropdown"
              >
                <img src="/images/profile/pic1.jpg" width="20" alt="" />
                <div className="header-info ms-3 align-items-center">
                  <span className="font-w600 ">Hi, Admin</span>
                  <small className="text-end font-w400"></small>
                </div>
              </a>
              <div className="dropdown-menu dropdown-menu-end">
                <a
                  href="/"
                  className="dropdown-item ai-icon"
                  onClick={handleClearLocalStorage}
                >
                  <svg
                    id="icon-logout"
                    xmlns="http://www.w3.org/2000/svg"
                    className="text-danger"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                    <polyline points="16 17 21 12 16 7"></polyline>
                    <line x1="21" y1="12" x2="9" y2="12"></line>
                  </svg>
                  <span className="ms-2">Logout </span>
                </a>
              </div>
            </li>

            <li>
              <Link to="/Dashboard">
                <Tooltip title="Dashboard">
                  <SpaceDashboardIcon />
                </Tooltip>

                <span class="nav-text">Dashboard</span>
              </Link>
            </li>

            {isModuleVisible("Master Merchant Management") && (
              <li>
                <Link
                  className={`${expandedmasterMerchant ? "expanded " : "custom-white-color"
                    }`}
                  to="/MasterMerchant/Submitted"
                  aria-expanded={expandedmasterMerchant}
                  onClick={() =>
                    handleToggle(
                      expandedmasterMerchant,
                      setExpandedMasterMerchant
                    )
                  }
                >
                  <Tooltip title="Master Merchant">
                    <AccountCircleIcon />
                  </Tooltip>

                  <span className="nav-text">Master Merchant</span>
                </Link>
              </li>
            )}

            {isModuleVisible("Vehicle Management") && (
              <li>
                <Link
                  className={`${expandedExternal ? "expanded " : "custom-white-color"
                    }`}
                  to="/ExternalMaster/Submitted"
                  aria-expanded={expandedExternal}
                  onClick={() =>
                    handleToggle(expandedExternal, setExpandedExternal)
                  }
                >
                  <Tooltip title="Vehicle Management">
                    <ContactEmergencyIcon />
                  </Tooltip>
                  <span className="nav-text">Vehicle Management</span>
                </Link>
              </li>
            )}

            {isModuleVisible("Masters") && (
              <li>
                <Link
                  className={`${expandedTools ? "expanded " : "custom-white-color"
                    }`}
                  to="/Masters"
                  aria-expanded={expandedmaster}
                  onClick={() =>
                    handleToggle(expandedmaster, setexpandedmaster)
                  }
                >
                  <Tooltip title="Masters">
                    <PersonIcon />
                  </Tooltip>
                  <span className="nav-text">Masters</span>
                </Link>
              </li>
            )}

            {isModuleVisible("Onboarding") && (
              <li>
                <Link
                  className={`${expandedonBoarding ? "expanded " : "custom-white-color"
                    }`}
                  to="/OnBoarding"
                  aria-expanded={expandedonBoarding}
                  onClick={() =>
                    handleToggle(expandedonBoarding, setexpandedonBoarding)
                  }
                >
                  <Tooltip title="On-Boarding">
                    <DisplaySettingsIcon />
                  </Tooltip>
                  <span className="nav-text">On-Boarding</span>
                </Link>
              </li>
            )}

            {hasAnyTools && (
              <li>
                <Link
                  className={`${expandedTools ? "expanded " : "custom-white-color"
                    }`}
                  to="/Tools"
                  aria-expanded={expandedTools}
                  onClick={() => handleToggle(expandedTools, setExpandedTools)}
                >
                  <Tooltip title="Tools">
                    <HandymanIcon />
                  </Tooltip>
                  <span className="nav-text">Tools</span>
                </Link>
              </li>
            )}

            {isModuleVisible("Reports") && (
              <li>
                <Link
                  className={`${expanded ? "expanded " : "custom-white-color"}`}
                  to="/Reports/LiveCummulativeReport"
                  aria-expanded={expanded}
                  onClick={() => handleToggle(expanded, setExpanded)}
                >
                  <Tooltip title="Reports">
                    <AssessmentIcon />
                  </Tooltip>
                  <span className="nav-text">Reports</span>
                </Link>
              </li>
            )}

            {isModuleVisible("Support") && (
              <li>
                <Link
                  className={`${expanded ? "expanded " : "custom-white-color"}`}
                  to="/Support"
                  aria-expanded={expanded}
                  onClick={() => handleToggle(expanded, setExpanded)}
                >
                  <Tooltip title="Support">
                    <HeadsetMicIcon />
                  </Tooltip>
                  <span className="nav-text">Support</span>
                </Link>
              </li>
            )}

            <li>
              <Link
                className={`${expandedCustomer ? "expanded " : "custom-white-color"
                  }`}
                to="#"
                aria-expanded={expandedCustomer}
                onClick={() =>
                  handleToggle(expandedCustomer, setexpandedCustomer)
                }
              >
                <Tooltip title="Customer-Support">
                  <SupportAgentIcon />
                </Tooltip>
                {/* <i class="fa-solid fa-headset"></i> */}
                <span className="nav-text">Customer Support</span>
              </Link>

              <ul
                className={`dropdown-menu shadow-none ${expandedCustomer ? "show" : ""
                  }`}
              >
                <li>
                  <Link to="/CustomerSupport/OnBoarding">On-Boarding</Link>
                </li>
                <li>
                  <Link to="/CustomerSupport/TechnicalSupport">
                    Technical Support
                  </Link>
                </li>
                <li>
                  <Link to="/CustomerSupport/RiskManagementSupport">
                    Risk Manag. Supp.
                  </Link>
                </li>
                <li>
                  <Link to="/CustomerSupport/Accounting">Accounting</Link>
                </li>
              </ul>
            </li>

            <li>
              <Link
                className={`${expandedSettings ? "expanded " : "custom-white-color"
                  }`}
                to="/Settings"
                aria-expanded={expandedSettings}
                onClick={() =>
                  handleToggle(expandedSettings, setExpandedSettings)
                }
              >
                <Tooltip title="Settings">
                  <SettingsIcon />
                </Tooltip>
                <span className="nav-text">Settings</span>
              </Link>
            </li>
          </ul>
          <div class="copyright">
            <p>
              <strong>Solwio</strong> © 2024 All Rights Reserved
            </p>
            <p class="fs-12">
              Made with <span class="heart"></span> by Solwio
            </p>
          </div>
        </div>
      </div>
    </>
  );
}